import React, {useState, useEffect, forwardRef, useImperativeHandle} from "react";
import axios from "axios";
import {API_URL} from "../../../services/api.service";
import {useAuthContext} from "../../../services/auth.service";
import {useDataContext} from "../../../services/data.service";
import {toast} from "react-hot-toast";

const NotesField = forwardRef(({image, onClose}, ref) => {
    const {token} = useAuthContext();
    const {setCurrentRecord} = useDataContext();
    const [notes, setNotes] = useState(image?.notes || "");
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (image?.notes !== undefined) {
            setNotes(image.notes || "");
        }
    }, [image]);

    const handleSave = () => {
        if (isSaving) return;
        setIsSaving(true);
        axios.post(`${API_URL}/images/${image.id}`, {
            notes: notes
        }, {headers: {"Authorization": `Bearer ${token}`}})
            .then(result => {
                if (result.data.success) {
                    toast.success(`Saved notes for image ${image.name}`, {position: "top-center"});
                    // We should update the current record in context if it's the same image
                    setCurrentRecord({...image, notes: notes});
                    onClose();
                } else {
                    toast.error("Failed to save notes: " + result.data.error);
                }
            })
            .catch(err => {
                toast.error("Error saving notes: " + err.message);
            })
            .finally(() => {
                setIsSaving(false);
            });
    };

    useImperativeHandle(ref, () => ({
        handleSave
    }));

    return (
        <div className="flex flex-col h-full">
            <textarea
                className="w-full h-64 p-2 border border-slate-300 rounded focus:ring-blue-500 focus:border-blue-500"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeholder="Enter notes here..."
                disabled={isSaving}
            />
        </div>
    );
});

export default NotesField;
